import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { IcsAttestationActions } from './ics-attestation.actions';
import { IcsAttestationService } from '../../service/ics-attestation.service';


@Injectable()
export class IcsAttestationEffects {

  getIcsAttestation$ = createEffect(
    (cd: IcsAttestationService = inject(IcsAttestationService)) => {
      return this.actions$.pipe(

        ofType(IcsAttestationActions.loadIcsAttestations),
        mergeMap(({ icsCampaignId, parameters, fields }) =>
          cd.getIcsAttestation(icsCampaignId, parameters).pipe(
            map((res) => {
              return IcsAttestationActions.loadIcsAttestationsSuccess({
                icsAttestation: res,
                fields
              });
            }),
            catchError((error) => of(IcsAttestationActions.loadIcsAttestationsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  getAllIcsAttestation$ = createEffect(
    (cd: IcsAttestationService = inject(IcsAttestationService)) => {
      return this.actions$.pipe(

        ofType(IcsAttestationActions.loadAllIcsAttestations),
        mergeMap(({ icsCampaignId, parameters, fields }) =>
          cd.getIcsAttestation(icsCampaignId, parameters).pipe(
            map((res) => {
              return IcsAttestationActions.loadAllIcsAttestationsSuccess({
                icsAttestation: res,
                fields
              });
            }),
            catchError((error) => of(IcsAttestationActions.loadIcsAttestationsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  updateIcsAttestation$ = createEffect(
    (cd: IcsAttestationService = inject(IcsAttestationService)) => {
      return this.actions$.pipe(

        ofType(IcsAttestationActions.updateIcsAttestations),
        mergeMap(({ updatedValue }) =>
          cd.updateIcsAttestation(updatedValue).pipe(
            map((res) => {
              return IcsAttestationActions.updateIcsAttestationsSuccess({
                icsAttestation: res
              });
            }),
            catchError((error) => of(IcsAttestationActions.updateIcsAttestationsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  updateChiefAttestationStatus$ = createEffect(
    (cd: IcsAttestationService = inject(IcsAttestationService)) => {
      return this.actions$.pipe(

        ofType(IcsAttestationActions.updateChiefAttestationStatus),
        mergeMap(({ answerId, attestationAnswerId }) =>
          cd.updateChiefAttestationStatus(attestationAnswerId, answerId).pipe(
            map((res) => {
              return IcsAttestationActions.updateChiefAttestationStatusSuccess({
                icsAttestation: res
              });
            }),
            catchError((error) => of(IcsAttestationActions.updateChiefAttestationStatusFailure({ error })))
          )
        )
      )
    },
    { functional: true }
  );

  downloadIcsAttestation$ = createEffect(
    (cd: IcsAttestationService = inject(IcsAttestationService)) => {
      return this.actions$.pipe(
        ofType(IcsAttestationActions.downloadIcsAttestation),
        mergeMap(({ query, icsCampaignId, timeZone }) =>
          cd.downloadIcsAttestation(query, icsCampaignId, timeZone).pipe(
            map((res: any) => {
              // Extract filename from the response
              const filename = res?.data?.[0]?.filename || 'export.xlsx';
              return IcsAttestationActions.downloadIcsAttestationSuccess({
                downloadUrl: '',
                fileName: filename
              });
            }),
            catchError((error) => of(IcsAttestationActions.downloadIcsAttestationFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  updateGaltsAttestationStatus$ = createEffect(
    (cd: IcsAttestationService = inject(IcsAttestationService)) => {
      return this.actions$.pipe(

        ofType(IcsAttestationActions.updateGaltAttestationStatus),
        mergeMap(({ answerId, attestationAnswerId }) =>
          cd.updateGaltsAttestationStatus(attestationAnswerId, answerId).pipe(
            map((res) => {
              return IcsAttestationActions.updateGaltAttestationStatusSuccess({
                icsAttestation: res
              });
            }),
            catchError((error) => of(IcsAttestationActions.updateGaltAttestationStatusFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );



  constructor(private actions$: Actions) { }
}
